<template>
  <div
    class="tab-head"
    :class="{ isActive: tab.isActive, isClosable: tab.isClosable }"
  >
    <router-link :to="tab.url" class="tab-link" :key="tab.path">
      <div class="tab-title" :class="{ selected: tab.isActive }">
        {{ tab.title }}
      </div>
    </router-link>
    <a-button
      v-if="tab.isClosable && isClosable"
      type="text"
      class="text-button icon close"
      @click="$emit('close')"
    >
      <close-outlined />
    </a-button>
  </div>
</template>
<script setup lang="ts">
import { CloseOutlined } from '@ant-design/icons-vue'
import type { Tab } from '@/libs/tab'

withDefaults(defineProps<{ tab: Tab; isClosable?: boolean }>(), {
  isClosable: true
})
</script>
<style scoped>
.tab-head {
  position: relative;
  height: 35px;
  background-color: var(--color-background-inactive);
  border: 1px solid var(--color-border);
  border-radius: 6px 6px 0 0;
  margin-right: 10px;
  display: inline-flex;
  transition: border-color 300ms ease-in-out;
}
.tab-link {
  display: inline-flex;
}
.tab-head:first-child {
  margin-left: 10px;
}
.tab-head:hover {
  border: 1px solid var(--a-color-primary-light-3);
  border-bottom: 1px solid var(--color-border);
}
.isActive {
  background-color: var(--color-background);
  border-bottom: 1px solid var(--color-background);
  z-index: 2;
  transition: unset;
}
.isActive:hover {
  border-bottom: 1px solid var(--color-background);
  transition: unset;
}
.isClosable {
  padding: 5px 8px 5px 10px;
}
.icon {
  width: 19px;
  height: 19px;
}
.close {
  padding: 0px;
  margin-top: 3px;
}
.close:hover {
  filter: brightness(0) saturate(100%) invert(67%) sepia(6%) saturate(165%)
    hue-rotate(169deg) brightness(87%) contrast(88%);
}
.status {
  padding: 8px 15px 0px 9px;
}
.tab-title {
  padding: 2px 5px 0 2px;
  user-select: auto;
  cursor: pointer;
  font-weight: 500;
}
.selected {
  color: var(--c-blue-bright);
  text-shadow: 0 0 0.25px currentColor;
}
</style>
